import React, { useEffect } from 'react';
import styled from 'styled-components';
import { StatCard } from './StatCard';
import { RiderPointsTable } from './RiderPointsTable';
import teamIcon from '../Assets/team.svg';
import showsIcon from '../Assets/shows.svg';
import ridesIcon from '../Assets/rides.svg';
import ridersIcon from '../Assets/riders.svg';
import { useDashboardApi } from '../useDashboardApi';
import { CardSkeletonLoader } from 'app/components/CardSkeletonLoader';

export const StatisticsSection: React.FC = () => {
  const { totalSummary, getTotalSummary, summaryLoading } = useDashboardApi();
  useEffect(() => {
    getTotalSummary();
  }, []);
  return (
    <SectionContainer>
      <StatsCardsContainer>
        {summaryLoading ? (
          <CardSkeletonLoader
            isHeaderLoader
            headerWidth={297}
            headerHeight={95}
          />
        ) : (
          <StatCard
            title="Total Shows"
            value={totalSummary?.totalShows || 0}
            iconSrc={showsIcon}
            customStyles={{
              backgroundColor: '#F1EBFFAD',
              border: '1px solid #B1B1B121',
            }}
          />
        )}
        {summaryLoading ? (
          <CardSkeletonLoader
            isHeaderLoader
            headerWidth={297}
            headerHeight={95}
          />
        ) : (
          <StatCard
            title="Total Team"
            value={totalSummary?.totalTeams || 0}
            iconSrc={teamIcon}
            customStyles={{
              backgroundColor: '#FFE3E3AB',
              border: '1px solid #B1B1B121',
            }}
          />
        )}
        {summaryLoading ? (
          <CardSkeletonLoader
            isHeaderLoader
            headerWidth={297}
            headerHeight={95}
          />
        ) : (
          <StatCard
            title="Total Rides"
            value={totalSummary?.totalRides || 0}
            iconSrc={ridesIcon}
            customStyles={{
              backgroundColor: '#F8FCED',
              border: '1px solid #B1B1B121',
            }}
          />
        )}
        {summaryLoading ? (
          <CardSkeletonLoader
            isHeaderLoader
            headerWidth={297}
            headerHeight={95}
          />
        ) : (
          <StatCard
            title="Total Riders"
            value={totalSummary?.totalRiders || 0}
            iconSrc={ridersIcon}
            customStyles={{
              backgroundColor: '#F5F7FF',
              border: '1px solid #B1B1B121',
            }}
          />
        )}
      </StatsCardsContainer>
      {/* <RiderPointsTable /> */}
    </SectionContainer>
  );
};

const SectionContainer = styled.section`
  display: flex;
  margin-top: 30px;
  width: 100%;
  align-items: start;
  gap: 40px;
  justify-content: start;
  flex-wrap: wrap;
  padding-bottom: 30px;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const StatsCardsContainer = styled.div`
  align-self: stretch;
  min-width: 240px;
  margin-top: auto;
  margin-bottom: auto;
  flex-grow: 1;
  flex-shrink: 1;
  width: 209px;
`;
